<template>
    <BarChart v-bind:title="title" v-bind:data="data"/>
</template>

<script>
import BarChart from "@/components/management/statistics/common/BarChart";
import {getChartData} from "@/api/prodtype";

export default {
  components: {
    BarChart,
  },
  data() {
    return {
      title : 'Document',
      data : [],
    };
  },
  // created() {
  //   this.getData();
  // },
  methods: {
    async getData(year, firstProdType, secondProdType) {
      let loader = this.$loading.show({});
      try {
        let response = await getChartData(year, firstProdType, secondProdType);
        console.log(response);
        this.data = response.data.result;
      } finally {
        loader.hide();
      }
    },
  }
};
</script>

<style>
</style>
